import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import { CARD_NAME_MAX_LENGTH } from 'const/limits'
import {
  CardModalView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import CardCopyAction from 'components/CardActions/Copy'

export class CopyCard extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    leftSidebar: PropTypes.object.isRequired,

    cardId: PropTypes.number.isRequired,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),

    name: PropTypes.string.isRequired,
    isTemplate: PropTypes.bool.isRequired,

    requestCopyCard: PropTypes.func.isRequired,
    requestAddCardTemplate: PropTypes.func.isRequired,
  }

  constructor (props) {
    super(props)

    this.handleValidate = this.handleValidate.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleValidate ({ name }) {
    const { intl } = this.props

    const errors = {}
    if (name && name.length > CARD_NAME_MAX_LENGTH) {
      errors.name = intl.formatMessage({ id: 'CARD_NAME_TOO_LONG' }, { limit: CARD_NAME_MAX_LENGTH })
    }
    return errors
  }

  handleSubmit ({ name }) {
    const { cardId, isTemplate, requestCopyCard, requestAddCardTemplate } = this.props

    if (name) {
      if (isTemplate) {
        requestAddCardTemplate({
          cardId,
          name
        })
      } else {
        requestCopyCard({
          cardId,
          name
        })
      }

      this.props.leftSidebar.close()
    }
  }

  render () {
    const {
      title,
      name
    } = this.props

    return (
      <CardModalView
        title={title}
      >
        <ViewBody>
          <CardCopyAction
            validate={this.handleValidate}
            onSubmit={this.handleSubmit}
            initialValues={{
              name
            }}
          />
        </ViewBody>
      </CardModalView>
    )
  }
}

export default injectIntl(withLeftSidebar(CopyCard))
